import { useState, useCallback } from 'react';
import { SocialSettings } from '../types';
import { socialService } from '../services/SocialService';

export const useSettings = () => {
    const [socialSettings, setSocialSettings] = useState<Partial<SocialSettings>>({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchSettings = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const settings = await socialService.getSettings();
            setSocialSettings(settings);
        } catch (err) {
            setError('Error al cargar la configuración');
            console.error('Error loading settings:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleSaveSocialSettings = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            await socialService.updateSettings(socialSettings);
            alert('Configuración guardada correctamente');
        } catch (err) {
            setError('Error al guardar la configuración');
            alert('Error al guardar la configuración');
        } finally {
            setLoading(false);
        }
    }, [socialSettings]);

    return {
        socialSettings,
        setSocialSettings,
        loading,
        error,
        fetchSettings,
        handleSaveSocialSettings
    };
};
